import { useCallback } from 'react';

export const useTogglePreloader = () => useCallback((isHidden: boolean) => {
    document.getElementById('preloader')?.classList.toggle('hidden', isHidden);
    document.getElementById('application')?.classList.toggle('hidden', !isHidden);
}, []);
